import { getTenantId } from 'src/app/services/store-snapshot.service';
import { IdName } from 'src/app/shared/models/id-name';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { ICompetenceRoleModel, ICompetenceRoleSimple } from '../model/competence-role.model';
import { ALL_DEPS_TOKEN } from 'src/app/tenant-selector/state/tenant-user-access.state';

@Injectable({
  providedIn: 'root',
})
export class CompetenceRolesApiService {
  private get baseUrl(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Roles`;
  }

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    params: new HttpParams(),
  };

  constructor(private http: HttpClient) {}

  getCompetenceRolesList(currentFilter?: MainTableFilterModel): Observable<ApiResponse<IdName[]>> {
    let params = new HttpParams();

    if (currentFilter?.pageSize) {
      params = params.append('Page', currentFilter.pageIndex.toString());
      params = params.append('PageSize', currentFilter.pageSize.toString());
    }
    if (currentFilter?.searchTerm) {
      params = params.append('GlobalSearch', currentFilter.searchTerm);
    }
    if (currentFilter?.orderBy && currentFilter.ascDesc) {
      params = params.append(`OrderBy[${currentFilter.orderBy}]`, currentFilter.ascDesc);
    }
    return this.http.get<ApiResponse<IdName[]>>(this.baseUrl, { params });
  }

  getAllCompetenceRoles(
    includeDeleted: boolean,
    departmentId?: string
  ): Observable<ICompetenceRoleSimple[]> {
    const url = `${this.baseUrl}/All`;
    let params = new HttpParams();
    if (includeDeleted) {
      params = params.append('IncludeDeleted', includeDeleted);
    }
    if (departmentId && departmentId !== ALL_DEPS_TOKEN) {
      params = params.append('DepartmentId', departmentId);
    }
    return this.http.get<ICompetenceRoleSimple[]>(url, { ...this.httpOptions, params });
  }

  getCompetenceRoleById(id: string): Observable<ICompetenceRoleModel> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<ICompetenceRoleModel>(url, this.httpOptions);
  }

  addCompetenceRole(role: IdName): Observable<void> {
    return this.http.post<void>(this.baseUrl, role, this.httpOptions);
  }

  updateCompetenceRole(role: IdName): Observable<void> {
    const url = `${this.baseUrl}/${role.id}`;
    return this.http.put<void>(url, role, this.httpOptions);
  }

  deleteCompetenceRole(id: string): Observable<void> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.delete<void>(url, this.httpOptions);
  }
}
